const r = {
  beta: "bg-beta-container",
  success: "bg-success-container",
  error: "bg-error-container",
  notice: "bg-notice-container",
  neutral: "bg-neutral-container",
  paywall: "bg-paywall-container",
  accent: "bg-accent-container"
}, a = {
  beta: "border-neutral-border",
  success: "border-success-border",
  error: "border-error-border",
  notice: "border-notice-border",
  neutral: "border-neutral-border",
  paywall: "border-paywall-border",
  accent: "border-accent-border"
}, e = ["bg-avatar-red", "bg-avatar-orange", "bg-avatar-yellow", "bg-avatar-green", "bg-avatar-purple", "bg-avatar-blue", "bg-avatar-teal", "bg-avatar-pink", "bg-avatar-ticket"];
export {
  e as AVATAR_COLORS,
  r as BACKGROUND_COLOR,
  a as BORDER_COLOR
};
